module.exports = __webpack_public_path__ + "static/media/morrisonsForOne.77fbf724.csv";